import React, { Component } from "react";
import { injectIntl, defineMessages } from "react-intl";
import axios from "axios";
import { Alert } from "reactstrap";
import Main from "./containers/Main";
import Contact from "./containers/Contact";
import SuccessPage from "./components/SuccessPage";
import { defaultStyle } from "./Utils/defaultStyle.js";
import conf from './conf';

const messages = defineMessages({
  errorMessage: {
    id: "App.errorMessage",
    defaultMessage: "We are sorry, there has been a server error.",
  },
});

class App extends Component {
  state = {
    allNodes: [],
    selectedNode: null,
    getTreeNodesError: false,
    sendSupportDataSuccess: false,
    sendSupportDataError: false,
    serverDataMissing: false,
    styles: {},
    historyNodes: null,
  };

  componentDidMount() {
    axios
      .get(`${conf.apiBaseUrl}/cs/tree-nodes`)
      .then((response) => {
        this.setState({
          allNodes: response.data.nodes,
          styles: response.data.styles ? response.data.styles : defaultStyle,
        });
      })
      .catch(() => {
        this.setState({
          getTreeNodesError: true,
        });
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.contactOption && !this.state.contactOption) {
      this.setState({
        ...this.state,
        serverDataMissing: false,
      });
    }
  }

  sendSupportData = (userData) => {
    const { selectedNode, contactOption } = this.state;

    if (selectedNode.categoryid && selectedNode.priorityid)
      axios
        .post(`${conf.apiBaseUrl}/cs/ticket`, {
          nodeId: selectedNode.nodeid,
          categoryId: selectedNode.categoryid,
          priorityId: selectedNode.priorityid,
          contactBy: contactOption,
          ...userData,
        })
        .then(() => {
          this.setState({
            ...this.state,
            sendSupportDataSuccess: true,
          });
        })
        .catch(() => {
          this.setState({
            ...this.state,
            sendSupportDataError: true,
          });
        });
    else {
      this.setState({
        ...this.state,
        serverDataMissing: true,
      });
    }
  };

  saveContactOption = (contactOption) => {
    this.setState({
      ...this.state,
      contactOption,
    });
  };

  saveNodeData = (leaf, historyNodes) => {
    this.setState({
      ...this.state,
      selectedNode: leaf,
      historyNodes: historyNodes,
    });
  };

  toggleAlert = () => {
    this.setState({
      ...this.state,
      serverDataMissing: false,
    });
  };

  render() {
    const {
      selectedNode,
      sendSupportDataSuccess,
      sendSupportDataError,
      allNodes,
      getTreeNodesError,
      styles,
      serverDataMissing,
    } = this.state;
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="App">
        <Alert
          color="danger"
          isOpen={serverDataMissing}
          toggle={this.toggleAlert}
        >
          {formatMessage(messages.errorMessage)}
        </Alert>
        {!sendSupportDataSuccess && !sendSupportDataError && !selectedNode && (
          <Main
            allNodes={allNodes}
            getTreeNodesError={getTreeNodesError}
            saveNodeData={this.saveNodeData}
            iconStyle={styles.iconStyle}
            bodyStyle={styles.bodyStyle}
            modalStyle={styles.modalStyle}
          />
        )}
        {!sendSupportDataSuccess && selectedNode && (
          <Contact
            onSubmit={this.sendSupportData}
            saveContactOption={this.saveContactOption}
            sendSupportDataError={sendSupportDataError}
            styles={styles}
            saveNodeData={this.saveNodeData}
            historyNodes={this.state.historyNodes}
          />
        )}
        {sendSupportDataSuccess && (
          <SuccessPage successPageStyle={styles.successPageStyle} />
        )}
      </div>
    );
  }
}

export default injectIntl(App);
